module.exports = __webpack_public_path__ + "img/Girl_030022.60d2bf7a.png";